import DataGrid from '../common/DataGrid';
import EditIcon from '@mui/icons-material/Edit';
import Header from '../common/layout/Header';
import React from 'react';
import {Button, Link, Switch, Typography} from '@mui/material';
import {DateTime} from 'luxon';
import {GridActionsCellItem} from '@mui/x-data-grid-pro';
import {Link as RouterLink, useHistory} from 'react-router-dom';
import {Routes} from '@account/utils/route';
import {
  useGetAccessRestrictions,
  useTogglePolicy,
} from '@account/api/archiveControl';

const Policies = () => {
  const history = useHistory();

  const accessRestrictionsQuery = useGetAccessRestrictions();
  const togglePolicy = useTogglePolicy();

  const columns = [
    {
      field: 'name',
      headerName: 'Name',
      flex: 0.65,
      renderCell: params => (
        <Link
          color="primary"
          underline="hover"
          component={RouterLink}
          to={`${Routes.ARCHIVE_CONTROL}/${params.row.id}`}
          onClick={e => e.stopPropagation()}
        >
          {params.value}
        </Link>
      ),
    },

    {
      field: 'created_at',
      headerName: 'Created',
      flex: 0.5,
      valueGetter: params => {
        return DateTime.fromISO(params.value, {zone: 'utc'}).toFormat('fff');
      },
    },
    {
      field: 'updated_at',
      headerName: 'Updated',
      flex: 0.5,
      valueGetter: params => {
        return DateTime.fromISO(params.value, {zone: 'utc'}).toFormat('fff');
      },
    },
    {
      field: 'enabled',
      headerName: 'Status',
      flex: 0.15,
      valueGetter: params => (params.value ? 'On' : 'Off'),
    },
    {
      field: 'actions',
      headerName: 'Actions',
      type: 'actions',
      flex: 0.25,
      getActions: params => {
        return [
          <Switch
            size="small"
            key="statusToggle"
            checked={params.row.enabled}
            onChange={event => {
              const {checked} = event.target;
              togglePolicy.mutate({policyId: params.row.id, enable: checked});
            }}
          />,
          <GridActionsCellItem
            key="edit"
            label="Edit"
            icon={<EditIcon />}
            onClick={() => {
              history.push(`${Routes.ARCHIVE_CONTROL}/${params.row.id}/edit`);
            }}
          />,
        ];
      },
    },
  ];

  return (
    <>
      <Header name="Archive Control Policies">
        <Button
          color="primary"
          variant="contained"
          onClick={() => {
            history.push(`${Routes.ARCHIVE_CONTROL}/new`);
          }}
        >
          Create Policy
        </Button>
      </Header>
      <Typography sx={{marginBlockEnd: 2, color: 'text.secondary'}}>
        Policies that block access to data (AOI, TOI, item types) for all
        organizations and users.
      </Typography>

      <DataGrid
        columns={columns}
        rows={accessRestrictionsQuery.data ?? []}
        loading={accessRestrictionsQuery.isLoading}
      />
    </>
  );
};

export default Policies;
